import { Grid, Typography, Box } from "@mui/material";
import * as React from "react";
import { getMatches } from "../../../../api/matches";
import { useEffect, useState, useRef, useContext, useCallback } from "react";
import { ThemeContext } from "../../../../themes/themes";
import TeamDataGrid from "../../../../components/analysis/teamDataGrid";
import MatchesGrid from "../../../../components/matchesGrid";
import {
  SpeedGauge,
  AgilityGauge,
  DefenseGauge,
  ClimbingSpeedGauge,
  MatchesLineChart,
  LevelFrequencyPieChart,
  AveragePointsPieChart,
  EndGameFrequencyPieChart,
  ScatterPlot,
} from "../../../../components/analysis/teamGraphs";

async function GetMatches(teamNumber, event) {
  try {
    // Fetch all matches if no filter is set
    const data = await getMatches("", 0, 10, teamNumber || "", event);
    if (!data?.body) throw new Error("Invalid API response");
    return data;
  } catch (error) {
    console.error("Error fetching matches:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

export default function StatisticsPage({ team, event, user }) {
  useEffect(() => {
    toggleTheme("analysis");
    getData(team, event);
  }, []);

  const getData = (teamNumber, eventCode) => {
    const fetchData = async () => {
      const result = await GetMatches(teamNumber, eventCode);
      try {
        const parsedData = JSON.parse(result?.body);
        setMatchData(Array.isArray(parsedData?.data) ? parsedData.data : []);
        console.log(Array.isArray(parsedData?.data) ? parsedData.data : []);
      } catch (error) {
        console.error("Error parsing match data:", error);
        setMatchData([]);
      }
    };

    fetchData();
  };

  //Graph Data

  const [matchData, setMatchData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const updateFilteredData = useCallback((e) => setFilteredData(e), []);
  const currentYear = new Date().getFullYear();
  const [eventList, setEventList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [searchBy, setSearchBy] = useState("team");
  const [dataSource, setDataSource] = useState("ignite_insights");
  const [selectedTeam, setSelectedTeam] = useState();
  const [selectedEvent, setSelectedEvent] = useState("");
  const [loading, setLoading] = useState(true);
  const [levelsData, setLevelsData] = useState([]);
  const [endgameTypeData, setEndgameTypeData] = useState([]);
  const [pointsData, setPointsData] = useState([]);
  const [perMatch, setPerMatch] = useState([]);
  const [averageSpeed, setAverageSpeed] = useState(0);
  const [averageAgility, setAverageAgility] = useState(0);
  const [averageDefense, setAverageDefense] = useState(0);
  const [averageClimbingSpeed, setAverageClimbingSpeed] = useState(0);
  const [averageMatchPoints, setAverageMatchPoints] = useState([]);
  const [widths, setWidths] = useState({});
  const { toggleTheme } = useContext(ThemeContext);

  const levelRef = useRef(null);
  const pointsRef = useRef(null);
  const endgameRef = useRef(null);
  const speedRef = useRef(null);
  const agilityRef = useRef(null);
  const defenseRef = useRef(null);
  const climbingRef = useRef(null);
  const matchByMatchRef = useRef(null);

  useEffect(() => {
    let tempLevelData = {
      totalLevel1: 0,
      totalLevel2: 0,
      totalLevel3: 0,
      totalLevel4: 0,

      totalSpeed: 0,
      totalAgility: 0,
      totalDefense: 0,
      totalClimbingSpeed: 0,
      nonZeroDefense: 0,
      nonZeroClimbingSpeed: 0,

      endgame_no_attempt_count: 0,
      endgame_parked_count: 0,
      endgame_failed_shallow_count: 0,
      endgame_failed_deep_count: 0,
      endgame_succeeded_shallow_count: 0,
      endgame_succeeded_deep_count: 0,

      total_auto_points: 0,
      total_teleop_points: 0,
      total_endgame_points: 0,
      total_match_points: 0,
    };

    let tempPerMatch = {
      matches: [],
      totalPoints: [],
      autoPoints: [],
      teleopPoints: [],
      endgamePoints: [],
    };

    filteredData?.forEach((record) => {
      tempLevelData["totalLevel1"] =
        Number(tempLevelData["totalLevel1"]) + Number(record.teleop_level1);
      tempLevelData["totalLevel2"] =
        Number(tempLevelData["totalLevel2"]) + Number(record.teleop_level2);
      tempLevelData["totalLevel3"] =
        Number(tempLevelData["totalLevel3"]) + Number(record.teleop_level3);
      tempLevelData["totalLevel4"] =
        Number(tempLevelData["totalLevel4"]) + Number(record.teleop_level4);
      tempLevelData["totalSpeed"] =
        Number(tempLevelData["totalSpeed"]) + Number(record.robot_speed);
      tempLevelData["totalAgility"] =
        Number(tempLevelData["totalAgility"]) + Number(record.robot_agility);
      tempLevelData["totalDefense"] =
        Number(tempLevelData["totalDefense"]) + Number(record.robot_defense);
      tempLevelData["totalClimbingSpeed"] =
        Number(tempLevelData["totalClimbingSpeed"]) +
        Number(record.robot_climbing_speed);

      if (record.robot_defense > 0) {
        tempLevelData["nonZeroDefense"]++;
      }
      if (record.robot_climbing_speed > 0) {
        tempLevelData["nonZeroClimbingSpeed"]++;
      }
      if (record.endgame_type === "no_attempt") {
        tempLevelData["endgame_no_attempt_count"]++;
      }
      if (record.endgame_type === "parked") {
        tempLevelData["endgame_parked_count"]++;
      }
      if (record.endgame_type === "failed_shallow") {
        tempLevelData["endgame_failed_shallow_count"]++;
      }
      if (record.endgame_type === "failed_deep") {
        tempLevelData["endgame_failed_deep_count"]++;
      }
      if (record.endgame_type === "succeeded_shallow") {
        tempLevelData["endgame_succeeded_shallow_count"]++;
      }
      if (record.endgame_type === "succeeded_deep") {
        tempLevelData["endgame_succeeded_deep_count"]++;
      }

      tempLevelData["total_auto_points"] =
        Number(tempLevelData["total_auto_points"]) + Number(record.auto_points);
      tempLevelData["total_teleop_points"] =
        Number(tempLevelData["total_teleop_points"]) +
        Number(record.teleop_points);
      tempLevelData["total_endgame_points"] =
        Number(tempLevelData["total_endgame_points"]) +
        Number(record.endgame_points);

      tempLevelData["total_match_points"] =
        Number(tempLevelData["total_match_points"]) +
        Number(record.match_points);

      tempPerMatch.matches.push(record.match_number);
      tempPerMatch.totalPoints.push(record.match_points);
      tempPerMatch.autoPoints.push(record.auto_points);
      tempPerMatch.teleopPoints.push(record.teleop_points);
      tempPerMatch.endgamePoints.push(record.endgame_points);
    });

    setLevelsData([
      {
        id: 0,
        value: tempLevelData.totalLevel1 / filteredData?.length,
        label: "AVG Level 1",
      },
      {
        id: 1,
        value: tempLevelData.totalLevel2 / filteredData?.length,
        label: "AVG Level 2",
      },
      {
        id: 2,
        value: tempLevelData.totalLevel3 / filteredData?.length,
        label: "AVG Level 3",
      },
      {
        id: 3,
        value: tempLevelData.totalLevel4 / filteredData?.length,
        label: "AVG Level 4",
      },
    ]);

    setEndgameTypeData([
      {
        id: 0,
        value: tempLevelData.endgame_no_attempt_count,
        label: "No Attempt",
      },
      {
        id: 1,
        value: tempLevelData.endgame_parked_count,
        label: "Parked",
      },
      {
        id: 2,
        value: tempLevelData.endgame_failed_shallow_count,
        label: "Failed Shallow",
      },
      {
        id: 3,
        value: tempLevelData.endgame_failed_deep_count,
        label: "Failed Deep",
      },
      {
        id: 4,
        value: tempLevelData.endgame_succeeded_shallow_count,
        label: "Succeeded Shallow",
      },
      {
        id: 5,
        value: tempLevelData.endgame_succeeded_deep_count,
        label: "Succeeded Deep",
      },
    ]);

    setPointsData([
      {
        id: 0,
        value: tempLevelData.total_auto_points / filteredData?.length,
        label: "AVG Auto Points",
      },
      {
        id: 1,
        value: tempLevelData.total_teleop_points / filteredData?.length,
        label: "AVG Teleop Points",
      },
      {
        id: 2,
        value: tempLevelData.total_endgame_points / filteredData?.length,
        label: "AVG Endgame Points",
      },
    ]);

    setAverageMatchPoints([
      {
        label: "AVG Match Points",
        value: tempLevelData.total_match_points / filteredData?.length,
        color: "#fb5d00",
      },
    ]);

    setPerMatch(tempPerMatch);

    setAverageSpeed(tempLevelData.totalSpeed / filteredData?.length);
    setAverageAgility(tempLevelData.totalAgility / filteredData?.length);
    setAverageDefense(
      tempLevelData.totalDefense / tempLevelData.nonZeroDefense
    );
    setAverageClimbingSpeed(
      tempLevelData.totalClimbingSpeed / tempLevelData.nonZeroClimbingSpeed
    );
    const updateWidths = () =>
      setWidths({
        levelWidth: levelRef.current?.offsetWidth,
        pointsWidth: pointsRef.current?.offsetWidth,
        endgameWidth: endgameRef.current?.offsetWidth,
        speedWidth: speedRef.current?.offsetWidth,
        agilityWidth: agilityRef.current?.offsetWidth,
        defenseWidth: defenseRef.current?.offsetWidth,
        climbingWidth: climbingRef.current?.offsetWidth,
        matchByMatchWidth: matchByMatchRef.current?.offsetWidth,
      });
    updateWidths();
  }, [filteredData]);
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center", ml: 1 }}
            >
              <Typography sx={{ mr: 1 }}>
                <b>Robot Statistics</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              ref={speedRef}
              sx={{ my: 2, justifyItems: "center" }}
            >
              <SpeedGauge
                averageSpeed={averageSpeed}
                width={widths.speedWidth * 0.4}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              ref={agilityRef}
              sx={{ my: 2, justifyItems: "center" }}
            >
              <AgilityGauge
                averageAgility={averageAgility}
                width={widths.agilityWidth * 0.4}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              ref={defenseRef}
              sx={{ my: 2, justifyItems: "center" }}
            >
              <DefenseGauge
                averageDefense={averageDefense}
                width={widths.defenseWidth * 0.4}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              ref={climbingRef}
              sx={{ my: 2, justifyItems: "center" }}
            >
              <ClimbingSpeedGauge
                averageClimbingSpeed={averageClimbingSpeed}
                width={widths.climbingWidth * 0.4}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              width: "95%",
              borderColor: "#daa64b",
              borderWidth: 1,
              borderStyle: "solid",
              borderRadius: 3,
              p: 1,
            }}
          >
            <MatchesGrid
              user={user}
              filter={{
                robot_number: team,
                event: event,
              }}
              updateFilteredDataParent={updateFilteredData}
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          ref={levelRef}
          sx={{ my: 2, display: "flex", justifyContent: "center" }}
        >
          <LevelFrequencyPieChart
            levelsData={levelsData}
            width={widths?.levelWidth * 0.6}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          ref={pointsRef}
          sx={{ my: 2, display: "flex", justifyContent: "center" }}
        >
          <AveragePointsPieChart
            pointsData={pointsData}
            avgMatchPoints={averageMatchPoints}
            width={widths.pointsWidth * 0.6}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          ref={endgameRef}
          sx={{ my: 2, display: "flex", justifyContent: "center" }}
        >
          <EndGameFrequencyPieChart
            endgameTypeData={endgameTypeData}
            width={widths.endgameWidth * 0.6}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          sx={{ width: "100%", justifyItems: "center" }}
        >
          <Box
            ref={matchByMatchRef}
            sx={{
              display: "flex",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              width: { xs: "100%", sm: "100%" },
            }}
          >
            <MatchesLineChart
              perMatch={perMatch}
              width={widths.matchByMatchWidth}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
